export default "__VITE_ASSET__16aee5ce__"